import {
  alpha,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  styled,
  TextField
} from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { TradeAreasType } from '../types'

const StyledInputAdornment = styled(InputAdornment, {
  shouldForwardProp: (prop) => prop !== 'disabled'
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  ...(disabled && {
    color: alpha(theme.palette.text.disabled, 0.15)
  })
}))

function RangeType({ type, distance, time, onChangeType, onChangeDistance, onChangeTime }) {
  const intl = useIntl()
  return (
    <FormControl size="small">
      <FormLabel id="trade-areas-range-type">
        <FormattedMessage id="analysis.tradeAreas.range" />
      </FormLabel>
      <RadioGroup
        value={type}
        row
        aria-labelledby="trade-areas-range-type"
        name="trade-areas-range-type-radio-group"
        onChange={(e) => {
          onChangeType(e.target.value as TradeAreasType)
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              value={TradeAreasType.Distance}
              control={<Radio size="small" />}
              label={intl.formatMessage({ id: 'analysis.tradeAreas.distance' })}
            />
            <TextField
              disabled={type !== TradeAreasType.Distance}
              size="small"
              variant="outlined"
              value={distance}
              type="number"
              name={`analysis-trade-areas-distance`}
              InputProps={{
                'aria-label': 'analysis-trade-areas-distance',
                endAdornment: (
                  <StyledInputAdornment position="end" disabled={type !== TradeAreasType.Distance}>
                    <FormattedMessage id="analysis.tradeAreas.meter" />
                  </StyledInputAdornment>
                )
              }}
              onChange={(event) => {
                const target = event.target as HTMLInputElement
                onChangeDistance(target.value)
              }}
              fullWidth={false}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              value={TradeAreasType.Time}
              control={<Radio size="small" />}
              label={intl.formatMessage({ id: 'analysis.tradeAreas.time' })}
            />
            <TextField
              disabled={type !== TradeAreasType.Time}
              size="small"
              variant="outlined"
              value={time}
              type="number"
              name={`analysis-trade-areas-time`}
              InputProps={{
                'aria-label': 'analysis-trade-areas-time',
                endAdornment: (
                  <StyledInputAdornment position="end" disabled={type !== TradeAreasType.Time}>
                    <FormattedMessage id="analysis.tradeAreas.second" />
                  </StyledInputAdornment>
                )
              }}
              onChange={(event) => {
                const target = event.target as HTMLInputElement
                onChangeTime(target.value)
              }}
              fullWidth={false}
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </FormControl>
  )
}

export default RangeType
